import React from 'react'
import { connect } from 'react-redux'
import { get, map, max, min, keys, sortBy, take, takeRight} from 'lodash'
import Dimensions from 'react-dimensions'
import { Origin } from 'redux-tooltip';
import { setSelectedCountry, setComparisonCountry, loadLatestByIndicator } from '../../state/actions'
import SunBurstChart from '../SunBurstChart'
import './index.css'

var d3 = require('d3')
const Ocircle = Origin.wrapBy('circle')

//# TODO: compute???
const availableYears = ["2014", "2016"]

class ScatterPlot extends React.PureComponent {

  state = {
    yYear: availableYears[1],
    xYear: availableYears[0],
  }

  handleSelectCountry = (countryCode) => (e) => {
    this.props.setSelectedCountry(countryCode)
  }

  componentWillMount(){
    if(!this.props.latestDataByIndicator){
      this.props.loadLatestByIndicator()
    }
  }

  render() {

    const {  containerWidth, margin=20,
      data, countries,
      countriesContinents, colorMode, countryMode,
      selectedCountry, comparisonCountry,
      latestDataByIndicator } = this.props

    const { yYear, xYear } = this.state
    const countryCodes = keys(data)
    const dataSeries = availableYears.reduce((accumulator, currentValue, currentIndex) => {

      accumulator[currentValue] = countryCodes.reduce((acc, cv, ci) => {
        acc[cv] = data[cv][currentValue]
        return acc
      }, {})
      return accumulator
    }, {})


    const height = containerWidth - margin * 2
    const width = containerWidth - margin * 2

    const containerStyle = {
      paddingLeft: margin
    }

    const labelsMargin = 150
    const chartWidth = 800 - labelsMargin
    const chartHeight = 800 - labelsMargin

    const sortedValues = sortBy(keys(dataSeries[yYear]).map(i => ({c:i, v:get(dataSeries[yYear][i], 'v')})), 'v')


    let pickedValues, chartCountryCodes, maxDomain=7, minDomain=1;

    if(countryMode === 'top'){
      pickedValues = takeRight(sortedValues, 25)
      chartCountryCodes = map(pickedValues, 'c')
      maxDomain = Math.ceil(max(map(pickedValues, 'v')))
      minDomain = Math.floor(min(map(pickedValues, 'v')))
    } else if (countryMode === 'bottom'){
      pickedValues = take(sortedValues, 25)
      maxDomain = Math.ceil(max(map(pickedValues, 'v')))
      minDomain = Math.floor(min(map(pickedValues, 'v')))
      chartCountryCodes = map(pickedValues, 'c')
    } else {
      chartCountryCodes = countryCodes
      // maxDomain = max(map(sortedValues, 'v'))
      // minDomain = min(map(sortedValues, 'v'))
    }

    const hScale = d3.scaleLinear().range([labelsMargin, 800]).domain([minDomain, maxDomain])
    const vScale = d3.scaleLinear().range([chartHeight, 0]).domain([minDomain, maxDomain])

    return (
      <div style={containerStyle}>
        {(selectedCountry !== null) && (

          <div className="ScatterPlot__chart_container" style={{height:height, width: width}} onClick={this.handleSelectCountry(null)}>
            <div className="ScatterPlot__overlay border-blue">
              <div className={`${ comparisonCountry ? 'ScatterPlot__overlay__box--double' : 'ScatterPlot__overlay__box' }`} onClick={(e)=> { e.stopPropagation()}}>
                <SunBurstChart latestDataByIndicator={latestDataByIndicator} countryCode={selectedCountry}/>
              </div>
              {(comparisonCountry !== null) && (
                <div className="ScatterPlot__overlay__box--double" onClick={(e)=> { e.stopPropagation()}}>
                  <SunBurstChart baseColor={'#F8A23A'}latestDataByIndicator={latestDataByIndicator} countryCode={comparisonCountry}/>
                </div>
              )}
            </div>
          </div>
        )}

      <svg height={height} width={width} className="ScatterPlot__svg" viewBox={`0 0 800 800`}>
        {/* grid */}
        <g>
          <rect className="ScatterPlot__grid" x={labelsMargin} width={chartWidth} height={chartHeight}></rect>
          { [2,3,4,5,6].map((d, di) => {
            if(d === minDomain || d === maxDomain){ return null}
            const datum = d; //hScale.invert(labelsMargin + (d * chartWidth / 100))
            return (<g key={datum}>
            {/* vertical line and label */}
            <line key={`${datum}-vertical`} className="ScatterPlot__grid" x1={hScale(datum)} y1={vScale(minDomain)} x2={hScale(datum)} y2={vScale(maxDomain)} ></line>
            <text x={hScale(datum)} y={chartHeight+10} key={`${datum}-vertical-label`} className="ScatterPlot__label--vertical">{d.toFixed(1)}</text>
            {/* horizontal line and label */}
            <line key={`${datum}-horizontal`} className="ScatterPlot__grid" x1={hScale(minDomain)} y1={vScale(datum)} x2={hScale(maxDomain)} y2={vScale(datum)} ></line>
            <text x={labelsMargin-10} y={vScale(datum)} key={`${datum}-horizontal-label`} className="ScatterPlot__label--horizontal">{d.toFixed(1)}</text>
            </g>)
          })}
          {/* diagonal line */}
          <line className="ScatterPlot__grid" x1={hScale(minDomain)} y1={vScale(minDomain)} x2={hScale(maxDomain)} y2={vScale(maxDomain)} ></line>
        </g>

        {/* xylabels */}
        <g>
          <text y={chartHeight-40} className="ScatterPlot__ylabel">
            <tspan x={labelsMargin-20} dx={0} dy={16}>SCORE</tspan>
            <tspan className="ScatterPlot__bigger_label" x={labelsMargin-20} dx={0} dy={20}>{this.state.yYear}</tspan>
          </text>
        </g>

        {/* ylabels */}
        <g>
          <text y={chartHeight+30}className="ScatterPlot__xlabel">
            <tspan x={labelsMargin}>SCORE</tspan>
            <tspan className="ScatterPlot__bigger_label" x={labelsMargin} dx={0} dy={20}>{this.state.xYear}</tspan>
          </text>
        </g>

        {/* circles */}
        <g>
          { chartCountryCodes.map(countryCode => {
            if(!dataSeries[xYear][countryCode] || !dataSeries[yYear][countryCode]) { return null}
            const cx = hScale(dataSeries[xYear][countryCode].v)
            const cy = vScale(dataSeries[yYear][countryCode].v)

            const cyMid = vScale(dataSeries[xYear][countryCode].v)

            let classModifier = '';
            if(colorMode === 'continent'){
              classModifier =  countriesContinents[countryCode] || ''
            } else {
              classModifier =  dataSeries[xYear][countryCode].v >= dataSeries[yYear][countryCode].v ? 'red' : 'blue'
            }

            return (
                <g key={countryCode}>
                <Ocircle
                  onClick={this.handleSelectCountry(countryCode)}
                  className={ selectedCountry ? 'ScatterPlot__disabled' :  `ScatterPlot_circle ScatterPlot__bisect ScatterPlot__bisect--${classModifier}`}
                  r={2} cx={cx} cy={cy}
                  content={`${countries[countryCode]} : ${dataSeries[xYear][countryCode].v} (${xYear}), ${dataSeries[yYear][countryCode].v} (${yYear})`}/>
                <line className={selectedCountry ? 'ScatterPlot__disabled' :  `ScatterPlot__bisect ScatterPlot__bisect--${classModifier}`} x1={cx} y1={cy} x2={cx} y2={cyMid}></line>
                </g>
            )
          })
          }
        </g>
      </svg>
      </div>
    )
  }
}


const mapStateToProps = (state, props) => ({
  //dataByCountry : getTrendDataByCountryAndIndicator(state, props),
  //indicators: state.indicators,
  countries: state.countries,
  latestDataByIndicator: state.latestDataByIndicator.data,
  selectedCountry: state.selectedCountry,
  comparisonCountry: state.comparisonCountry,
  countriesContinents: state.countriesContinents,
  colorMode: state.colorMode,
  countryMode: state.countryMode,
})

const mapDispatchToProps = { setSelectedCountry, setComparisonCountry, loadLatestByIndicator }

export default connect(mapStateToProps, mapDispatchToProps)(Dimensions()(ScatterPlot))



// WEBPACK FOOTER //
// ./src/components/ScatterPlot/index.js